import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BookingStatusChangeConfirmationQuickcommerseModalComponent } from "./booking-status-change-confirmation-quickcommerse-modal/booking-status-change-confirmation-quickcommerse-modal.component";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { PipesModule } from "../pipes/pipes.module";

@NgModule({
  declarations: [BookingStatusChangeConfirmationQuickcommerseModalComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTooltipModule,
    PipesModule,
    NgSelectModule,
  ],
  exports: [BookingStatusChangeConfirmationQuickcommerseModalComponent]
})
export class QuickCommerceSharedComponentsModule {}
